import { observer } from "mobx-react";
import { IStepComponent } from "../../onboarding-page";
import WalletConfigurationStore from "../../stores/wallet-configuration-store";
import "./wallet-configuration-onboarding-screen.scss";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";
import WalletConfigurationNavigationControls from "./wallet-configuration-navigation-controls/wallet-configuration-navigation-controls";
import { WalletStore } from "../../../billing/stores/wallet/wallet-store";
import PaymentMethodErrorScreen from "./screens/payment-method-error-screen/payment-method-error-screen";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import PaymentMethodConfigurationScreen from "./screens/payment-method-configuration-screen/payment-method-configuration-screen";
import AddingPaymentMethodScreen from "./screens/adding-payment-method-screen/adding-payment-method-screen";

export interface IWalletConfigurationOnboardingScreenProps {
    store: WalletConfigurationStore;
    walletStore: WalletStore;
    getTranslation: (key: string, scope: string) => string;
    scope: string;
}

export enum WALLET_SCREEN_TYPE {
    ADDING_PAYMENT_METHOD = 'adding-payment-method',
    PAYMENT_METHOD_CONFIGURATION = 'payment-method-configuration',
    PAYMENT_METHOD_ERROR = 'payment-method-error',
}

const walletScreenComponentsMap = {
    [WALLET_SCREEN_TYPE.ADDING_PAYMENT_METHOD]: AddingPaymentMethodScreen,
    [WALLET_SCREEN_TYPE.PAYMENT_METHOD_CONFIGURATION]: PaymentMethodConfigurationScreen,
    [WALLET_SCREEN_TYPE.PAYMENT_METHOD_ERROR]: PaymentMethodErrorScreen,
};

const WalletConfigurationOnboardingScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as WalletConfigurationStore;
    const walletStore = store.walletStore;
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';

    const CurrentWalletScreen = walletScreenComponentsMap[store.currentWalletScreen];

    return (
        <div className="wallet-configuration-onboarding-screen">
            <CurrentWalletScreen 
                walletStore={walletStore} 
                getTranslation={getTranslation} 
                scope={scope} 
                store={store} 
            />            
            
            <OnboardingWizardStickyFooterPortal>
                <WalletConfigurationNavigationControls store={store} />
            </OnboardingWizardStickyFooterPortal>
        </div>
    );
});

export default WalletConfigurationOnboardingScreen;
